import React from "react";
import { NavLink } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";

export function LoginView({
  onLogin,
  emailRef,
  passwordRef,
  errorMessage,
  back,
}) {
  return (
    <>
      <div className="w-full h-full flex flex-col items-center justify-center">
        <h1 className="text-3xl mb-8">Login</h1>
        <form className="flex flex-col items-stretch" autoComplete="off">
          <div className="mb-2 flex items-center justify-between">
            <label className="mr-4" htmlFor="email-address">
              Email
            </label>
            <input
              ref={emailRef}
              className="rounded p-2"
              id="email-address"
              name="email"
              type="email"
              required
              placeholder="Email"
              onChange={() => {}}
            />
          </div>

          <div className="mv-4 flex items-center justify-between">
            <label className="mr-4" htmlFor="password">
              Password
            </label>
            <input
              ref={passwordRef}
              className="rounded p-2"
              id="password"
              name="password"
              type="password"
              required
              placeholder="Password"
              onChange={() => {}}
            />
          </div>

          <div className="flex items-center justify-between mt-4">
            <div className="text-xs mr-4">
              No account yet?{" "}
              <NavLink className="link-primary" to="/signup">
                Sign up
              </NavLink>
            </div>
          </div>

          <div className="flex items-center justify-between mt-4 mb-4">
            <button className="btn-secondary py-2" onClick={back}>
              <IoChevronBack />
              Back
            </button>
            <button className="btn-primary" onClick={onLogin}>
              Login
            </button>
          </div>

          {errorMessage && (
            <div className="flex items-center justify-center w-full mt-8">
              <p className="text-red capitalize">
                {errorMessage.slice(5).replace(/-/g, " ")}
              </p>
            </div>
          )}
        </form>
      </div>
    </>
  );
}

export default LoginView;
